import React from 'react';

import { Box, Flex } from '@chakra-ui/react';
import {
  Button,
  Dropdown,
  DropdownContent,
  DropdownItem,
  DropdownRadioGroup,
  DropdownRadioItem,
  DropdownSub,
  DropdownSubContent,
  DropdownSubTrigger,
  DropdownTrigger,
} from '@mesh.ai/rabbit';

import { Ellipsis } from 'assets/assetsV1/iconComponents';

import { TextLabel } from 'uiToolkitV1/Typography';

type Props = {
  options: Array<{
    label: string;
    onClick?: () => void;
    Icon?: React.FC;
    type?: 'subMenu' | 'default' | 'radio' | 'radioSubMenu';
    subOptions?: Array<{
      label: string;
      onClick: () => void;
      Icon?: React.FC;
      description?: string;
    }>;
    value?: string;
  }>;
  selectedRadioValue?: string;
  disableEllipsisMenu?: boolean;
};

const AgGridEllipsisMenu = ({ options, selectedRadioValue, disableEllipsisMenu = false }: Props) => {
  const disableStyleProps = disableEllipsisMenu ? { pointerEvents: 'none', opacity: 0.4 } : {};

  return (
    // @ts-expect-error union too complex
    <Flex h="100%" alignItems="center" justifyContent="center" {...disableStyleProps}>
      <Dropdown>
        <DropdownTrigger asChild>
          <Button variant="text">
            <Ellipsis boxSize="24px" />
          </Button>
        </DropdownTrigger>
        <DropdownContent
          align="end"
          style={{
            width: '280px',
          }}
        >
          {options?.map((option) => {
            const { label, onClick, Icon, type = 'default', subOptions, value } = option;
            const isSubtype = type === 'subMenu' || type === 'radioSubMenu';
            const isDefaultType = type === 'default';
            const isRadioType = type === 'radio';
            const IconExists = !!Icon;
            return (
              <Box key={label} w="100%">
                {isSubtype ? (
                  <DropdownSub>
                    <DropdownSubTrigger
                      style={{
                        width: '100%',
                      }}
                    >
                      <Box w="100%">
                        {IconExists && <Icon mr="8px" color="currentColor" boxSize="24px" />}
                        <span>{label}</span>
                      </Box>
                    </DropdownSubTrigger>
                    <DropdownSubContent
                      align="end"
                      style={{
                        width: '280px',
                      }}
                    >
                      {subOptions?.map((subOption) => {
                        const { label: _label, onClick: _onClick, Icon: Icon1, description } = subOption;
                        const IconExists1 = !!Icon1;
                        return (
                          <DropdownItem
                            key={_label}
                            onSelect={_onClick}
                            style={{
                              width: '100%',
                            }}
                          >
                            <Flex flexDir="column">
                              <Flex alignItems="center">
                                {IconExists1 && <Icon1 mr="8px" color="currentColor" boxSize="24px" />}
                                <span>{_label}</span>
                              </Flex>
                              {description && <TextLabel color="text.g2">{description}</TextLabel>}
                            </Flex>
                          </DropdownItem>
                        );
                      })}
                    </DropdownSubContent>
                  </DropdownSub>
                ) : null}
                {isDefaultType ? (
                  <DropdownItem
                    key={label}
                    onSelect={onClick}
                    style={{
                      width: '100%',
                    }}
                  >
                    <Flex alignItems="center">
                      {IconExists && <Icon mr="8px" color="currentColor" boxSize="24px" />}
                      <span>{label}</span>
                    </Flex>
                  </DropdownItem>
                ) : null}
                {isRadioType ? (
                  <DropdownRadioGroup value={selectedRadioValue}>
                    <DropdownRadioItem
                      key={label}
                      onSelect={onClick}
                      style={{
                        width: '100%',
                      }}
                      value={value}
                    >
                      <Flex alignItems="center">
                        {IconExists && <Icon mr="8px" color="currentColor" boxSize="24px" />}
                        <span>{label}</span>
                      </Flex>
                    </DropdownRadioItem>
                  </DropdownRadioGroup>
                ) : null}
              </Box>
            );
          })}
        </DropdownContent>
      </Dropdown>
    </Flex>
  );
};

export { AgGridEllipsisMenu };
